import React from 'react'
import { Row } from '@ztechapps/webui.data-tools'

export const ListRow = ({ ...props }) => {
  return (
    <Row {...props}>
      <td style={{ width: '20%' }} className={'p-2'}>
        <small className={'fw-bold'}> {props.fieldName}</small>
      </td>
      <td className={'p-2'}>
        <small> {props.value}</small>
      </td>
    </Row>
  )
}
